export default __webpack_public_path__ + "static/media/chrome-desktop-2.bfae145f.png";